import {
    ConfirmDialogOptions,
    confirmDialog as primeConfirmDialog,
} from "primereact/confirmdialog";

export const confirmDialog = (options: Partial<ConfirmDialogOptions>) =>
    primeConfirmDialog({
        draggable: false,
        dismissableMask: true,
        ...options,
    });
